/**
 * sessionStorage-backed Task Dashboard "hide all non-compliance" preference.
 *
 * Lifetime: browser `sessionStorage` — per tab, gone when the tab closes.
 * Keyed by tenant + user so the preference stays private per user and never
 * leaks across users on the same browser or across tenants.
 * Display only: not a server filter, and Clear filters does not remove it.
 *
 * REBUILD-345
 */

export const HIDE_NON_COMPLIANCE_ALL_STORAGE_PREFIX = 'ell.taskDashboard.hideNonComplianceAll.v1'

const STORED_ON = '1'

export const hideNonComplianceAllStorageKey = (
  tenantId: number | null | undefined,
  userId: number | null | undefined,
): string =>
  `${HIDE_NON_COMPLIANCE_ALL_STORAGE_PREFIX}:tenant:${tenantId ?? 'unknown'}:user:${userId ?? 'unknown'}`

const isSessionStorageAvailable = (): boolean => typeof sessionStorage !== 'undefined'

export const readHideNonComplianceAll = (
  tenantId: number | null | undefined,
  userId: number | null | undefined,
): boolean => {
  if (tenantId == null || !isSessionStorageAvailable()) return false

  try {
    return sessionStorage.getItem(hideNonComplianceAllStorageKey(tenantId, userId)) === STORED_ON
  } catch {
    return false
  }
}

export const writeHideNonComplianceAll = (
  tenantId: number | null | undefined,
  userId: number | null | undefined,
  hideAll: boolean,
): void => {
  if (tenantId == null || !isSessionStorageAvailable()) return

  const storageKey = hideNonComplianceAllStorageKey(tenantId, userId)
  try {
    if (hideAll) {
      sessionStorage.setItem(storageKey, STORED_ON)
    } else {
      sessionStorage.removeItem(storageKey)
    }
  } catch {
    // QuotaExceededError / SecurityError — persistence is best-effort.
  }
}
